import IssuesDashboard from './IssuesDashboard';
export default IssuesDashboard;
